import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=1559e926&scoped=true&"
import script from "./LanguageSelect.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=1559e926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1559e926",
  null
  
)

export default component.exports